import AndroidInstall from "../../../../contents/docs/integrate/_snippets/install-android.mdx";
import * as React from 'react';
export default {
  AndroidInstall,
  React
};